import React from "react";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useSendMailMessage } from "../hooks";

interface IProps {
  customerId?: number;
  defaultTo?: string;
  onCompleted: () => void;
}

export const SendMailMessageForm: React.FC<IProps> = ({
  customerId,
  defaultTo,
  onCompleted,
}) => {
  const { form, submit, loading } = useSendMailMessage({
    defaultValues: { customerId, to: defaultTo ?? "" },
    onCompleted: () => {
      form.reset({ customerId, to: defaultTo ?? "" });
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      <Input
        label="Destinataire"
        type="email"
        className="w-full"
        {...form.register("to", { required: true })}
        placeholder="destinataire@exemple.fr"
      />
      <Input
        label="Sujet"
        className="w-full"
        {...form.register("subject", { required: true })}
      />
      <Textarea
        label="Message"
        className="w-full"
        {...form.register("body", { required: true })}
        placeholder="Contenu de l'email..."
      />
      <Button onClick={submit} loading={loading} disabled={loading}>
        Envoyer l'email
      </Button>
    </div>
  );
};
